module.exports = __webpack_public_path__ + "static/img/pptx.9ec24d3f.png";